import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import QRCode from "qrcode.react";
import html2canvas from "html2canvas";
import ToastComponent from "../Common/TaostComponent";

const AccountShareModal = (props) => {
  const [isVisible, setIsVisible] = useState(true); // Set initial visibility
  const copyToClipboard = () => {
    // Create a temporary input element
    const tempInput = document.createElement("textarea");
    tempInput.value = `${process.env.REACT_APP_FRONT_URL}account-hub?account_name=${props.accountDetails?.username}`;
    document.body.appendChild(tempInput);

    // Select the text in the input element
    tempInput.select();
    tempInput.setSelectionRange(0, 99999); // For mobile devices

    // Copy the selected text to the clipboard
    document.execCommand("copy");

    ToastComponent("Fantasy Hub name copied to clipboard!", "success");
    // Remove the temporary input element
    document.body.removeChild(tempInput);
  };
  const captureImage = async (e) => {
    e.preventDefault();

    const modalContent = document.getElementById("playermoreinfo");
    if (modalContent) {
      // Hide the div before capturing the image
      setIsVisible(false);

      // Wait for the state update to complete before capturing the image
      await new Promise((resolve) => setTimeout(resolve, 100));

      html2canvas(modalContent, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props.accountDetails?.username}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);

        // Show the div again after capturing the image
        setIsVisible(true);
      });
    }
  };

  return (
    <>
      <>
        <Modal
          show={props.showAccountShareModal}
          onHide={() => props.setShowAccountShareModal(false)}
          size="lg"
          id="playermoreinfo"
        >
          <div className="gameprofile11 open11">
            <div className="gamevideo">
              <figure>
                <img src="/images/video-img.jpg" alt="img" />
              </figure>
            </div>
            <figure className="user-profile">
              {props.accountDetails && props.accountDetails?.club_logo && (
                <img
                  src={`${process.env.REACT_APP_CLUB_PROFILE}${props.accountDetails?.club_logo}`}
                  width="70"
                  height="70"
                  alt="img"
                />
              )}
              {!props.clubDetails ||
                (!props.clubDetails?.logo && (
                  <img src="images/brand-logo.png" alt="img" />
                ))}
            </figure>
            <div className="profile-content">
              <h4>{props.accountDetails?.club_name}</h4>
              <div className="admindetail"></div>
              <QRCode
                value={`${process.env.REACT_APP_FRONT_URL}account-hub?account_name=${props.accountDetails?.username}`} // The data or link the QR code will encode
                // size={256} // Size of the QR code
                renderAs="canvas" // Render the QR code as a canvas
                includeMargin={true} // Include margins around the QR code
              />

              <p>
                Invite members to join & play fantasy games on your Fantasy Hub!
              </p>
            </div>
          </div>

          <Modal.Footer>
            <div className="poweredby">
              Powered By
              <img src="/images/logo.png" alt="img" />
            </div>

            {isVisible && (
              <div className="hideClass">
                <Link
                  className="border-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    copyToClipboard();
                  }}
                >
                  <i class="fas fa-link"></i>
                </Link>
                <Link
                  onClick={captureImage}
                  className="border-btn"
                  style={{ textDecorationNo: "none", color: "black" }}
                >
                  <i className="fas fa-download"></i>
                </Link>
                <Link
                  className="border-btn"
                  onClick={(e) => {
                    e.preventDefault();
                    props.setShowAccountShareModal(false);
                  }}
                >
                  <i className="fas fa-times"></i>
                </Link>
              </div>
            )}
          </Modal.Footer>
        </Modal>
      </>
    </>
  );
};

export default AccountShareModal;
